export const translations = {
  pt: {
    nav: {
      about: 'Sobre',
      skills: 'Habilidades',
      projects: 'Projetos',
      contact: 'Contato'
    },
    hero: {
      title: 'Backend Developer',
      subtitle: 'Automação & Integrações SAP',
      description: 'Automatizo processos corporativos, integro sistemas críticos e transformo operações manuais em soluções escaláveis, seguras e eficientes.',
      cta1: 'Ver Projetos',
      cta2: 'Falar Comigo'
    },
    about: {
      title: 'Sobre Mim',
      p1: 'Sou desenvolvedor backend com forte atuação em automação de processos corporativos e integrações SAP. Trabalho conectando sistemas legados a arquiteturas modernas, reduzindo esforço operacional, erros manuais e gargalos de negócio.',
      p2: 'Tenho experiência em ambientes empresariais complexos, lidando com SAP ECC / S/4HANA, APIs, mensageria e RPAs, sempre com foco em resultado, performance e confiabilidade.',
      p3: 'Meu objetivo é simples: fazer a tecnologia trabalhar pelo negócio, não o contrário.'
    },
    skills: {
      title: 'Habilidades Técnicas',
      languages: {
        title: 'Linguagens',
        items: ['Python', 'C#', 'Java', 'TypeScript']
      },
      backend: {
        title: 'Backend & Integrações',
        items: ['APIs REST e SOAP', 'Integrações síncronas e assíncronas', 'Arquitetura orientada a serviços']
      },
      sap: {
        title: 'SAP',
        items: ['SAP ECC / S/4HANA', 'RFC, BAPI, IDoc', 'Automação via SAP GUI', 'Integração SAP ↔ sistemas externos']
      },
      automation: {
        title: 'Automação',
        items: ['RPA corporativo', 'Scripts de apoio operacional', 'Orquestração de processos']
      },
      messaging: {
        title: 'Mensageria',
        items: ['Filas e eventos', 'Processamento assíncrono', 'Alta confiabilidade e resiliência']
      },
      practices: {
        title: 'Boas Práticas',
        items: ['Código limpo', 'Logs e rastreabilidade', 'Tratamento robusto de erros', 'Foco em performance e escalabilidade']
      }
    },
    specialty: {
      title: 'Especialidade: Automações SAP',
      description: 'Atuo diretamente na automação de processos SAP ponta a ponta, eliminando tarefas manuais, retrabalho e dependência operacional.',
      whatIDo: 'O que faço na prática:',
      items: [
        'Automação de transações SAP (MM, SD, FI)',
        'Criação automática de documentos (ex: pedidos, contratos, lançamentos)',
        'Extração e processamento massivo de dados SAP',
        'Integração SAP com APIs, bancos de dados e sistemas externos',
        'Monitoramento e controle de falhas com rastreabilidade completa'
      ],
      results: 'Resultado típico:',
      resultItems: [
        'Redução de tempo operacional',
        'Menos erros humanos',
        'Processos mais previsíveis e auditáveis',
        'Ganho real de escala'
      ]
    },
    workTypes: {
      title: 'Tipos de Trabalho que Realizo',
      items: [
        'Automações SAP sob medida',
        'Integrações SAP ↔ sistemas externos',
        'Desenvolvimento de APIs corporativas',
        'RPAs para processos operacionais e financeiros',
        'Refatoração e modernização de sistemas legados',
        'Sustentação técnica e evolução de soluções existentes'
      ]
    },
    projects: {
      title: 'Projetos & Cases',
      items: [
        {
          title: 'Automação de Criação de Pedidos no SAP (MM)',
          problem: 'Processo manual de criação de pedidos no SAP consumia tempo do time e gerava erros frequentes.',
          solution: 'Desenvolvi uma automação que lê dados via API, valida regras de negócio e executa a criação automática de pedidos no SAP.',
          tech: 'Python, SAP GUI Automation, SAP ECC',
          result: 'Redução drástica do tempo operacional e eliminação de erros manuais.'
        },
        {
          title: 'Extração Massiva de Dados SAP para BI',
          problem: 'Dificuldade em extrair grandes volumes de dados SAP para análise e relatórios.',
          solution: 'Integração via RFC para extração estruturada de dados, com processamento e envio para sistema externo.',
          tech: 'Python, SAP RFC, APIs REST',
          result: 'Dados confiáveis, atualizados e prontos para análise estratégica.'
        },
        {
          title: 'Integração SAP ↔ Sistema Externo via API',
          problem: 'Sistema externo precisava consumir dados SAP em tempo quase real.',
          solution: 'Criação de API intermediária para orquestrar comunicação entre SAP e sistema externo, com tratamento de erros e logs.',
          tech: 'C#, REST API, SAP ECC, JSON',
          result: 'Integração estável, rastreável e escalável.'
        },
        {
          title: 'RPA para Processos Financeiros SAP (FI)',
          problem: 'Lançamentos financeiros repetitivos e suscetíveis a erro.',
          solution: 'RPA para automatizar lançamentos no SAP, com validações e controle de status.',
          tech: 'Python, SAP GUI, RPA',
          result: 'Aumento de produtividade e redução de inconsistências contábeis.'
        },
        {
          title: 'Orquestração de Múltiplos RPAs',
          problem: 'Execução manual e desorganizada de vários RPAs dependentes entre si.',
          solution: 'Script de orquestração controlando execução sequencial, status e falhas.',
          tech: 'Python, automação de processos',
          result: 'Processo previsível, controlado e fácil de escalar.'
        },
        {
          title: 'Sistema de Notificação de Pendências Integrado ao SAP',
          problem: 'Requisições incompletas no SAP geravam atrasos e retrabalho.',
          solution: 'Sistema que identifica pendências no SAP e dispara notificações automáticas por e-mail.',
          tech: 'TypeScript, APIs, SAP, mensageria',
          result: 'Menos follow-ups manuais e maior eficiência operacional.'
        }
      ],
      labels: {
        problem: 'Problema',
        solution: 'Solução',
        tech: 'Tecnologias',
        result: 'Resultado'
      }
    },
    forCompanies: {
      title: 'Para Empresas e Freelancers',
      intro: 'Atuo tanto em:',
      types: [
        'Vagas CLT ou PJ',
        'Projetos freelancer sob demanda',
        'Parcerias técnicas recorrentes'
      ],
      differentials: 'Diferenciais:',
      diffItems: [
        'Comunicação direta e objetiva',
        'Visão de negócio, não só código',
        'Entregas mensuráveis',
        'Soluções pensadas para produção real'
      ]
    },
    contact: {
      title: 'Vamos Conversar?',
      subtitle: 'Vamos automatizar seu processo ou evoluir seu sistema?',
      cta: 'Falar no WhatsApp',
      email: 'E-mail',
      linkedin: 'LinkedIn',
      github: 'GitHub'
    },
    footer: {
      rights: '© 2025 Lucas Gonzales de Souza. Todos os direitos reservados.',
      tagline: 'Desenvolvendo soluções que transformam negócios'
    }
  },
  en: {
    nav: {
      about: 'About',
      skills: 'Skills',
      projects: 'Projects',
      contact: 'Contact'
    },
    hero: {
      title: 'Backend Developer',
      subtitle: 'Automation & SAP Integrations',
      description: 'I automate corporate processes, integrate critical systems, and transform manual operations into scalable, secure, and efficient solutions.',
      cta1: 'View Projects',
      cta2: 'Contact Me'
    },
    about: {
      title: 'About Me',
      p1: 'I am a backend developer with strong expertise in corporate process automation and SAP integrations. I work connecting legacy systems to modern architectures, reducing operational effort, manual errors, and business bottlenecks.',
      p2: 'I have experience in complex enterprise environments, working with SAP ECC / S/4HANA, APIs, messaging, and RPAs, always focused on results, performance, and reliability.',
      p3: 'My goal is simple: make technology work for the business, not the other way around.'
    },
    skills: {
      title: 'Technical Skills',
      languages: {
        title: 'Languages',
        items: ['Python', 'C#', 'Java', 'TypeScript']
      },
      backend: {
        title: 'Backend & Integrations',
        items: ['REST and SOAP APIs', 'Synchronous and asynchronous integrations', 'Service-oriented architecture']
      },
      sap: {
        title: 'SAP',
        items: ['SAP ECC / S/4HANA', 'RFC, BAPI, IDoc', 'SAP GUI Automation', 'SAP ↔ external systems integration']
      },
      automation: {
        title: 'Automation',
        items: ['Corporate RPA', 'Operational support scripts', 'Process orchestration']
      },
      messaging: {
        title: 'Messaging',
        items: ['Queues and events', 'Asynchronous processing', 'High reliability and resilience']
      },
      practices: {
        title: 'Best Practices',
        items: ['Clean code', 'Logs and traceability', 'Robust error handling', 'Focus on performance and scalability']
      }
    },
    specialty: {
      title: 'Specialty: SAP Automations',
      description: 'I work directly on end-to-end SAP process automation, eliminating manual tasks, rework, and operational dependencies.',
      whatIDo: 'What I do in practice:',
      items: [
        'SAP transaction automation (MM, SD, FI)',
        'Automatic document creation (e.g., orders, contracts, postings)',
        'Massive SAP data extraction and processing',
        'SAP integration with APIs, databases, and external systems',
        'Failure monitoring and control with full traceability'
      ],
      results: 'Typical results:',
      resultItems: [
        'Reduced operational time',
        'Fewer human errors',
        'More predictable and auditable processes',
        'Real scale gains'
      ]
    },
    workTypes: {
      title: 'Types of Work I Do',
      items: [
        'Custom SAP automations',
        'SAP ↔ external systems integrations',
        'Corporate API development',
        'RPAs for operational and financial processes',
        'Legacy system refactoring and modernization',
        'Technical support and solution evolution'
      ]
    },
    projects: {
      title: 'Projects & Cases',
      items: [
        {
          title: 'SAP Order Creation Automation (MM)',
          problem: 'Manual order creation process in SAP consumed team time and generated frequent errors.',
          solution: 'Developed an automation that reads data via API, validates business rules, and executes automatic order creation in SAP.',
          tech: 'Python, SAP GUI Automation, SAP ECC',
          result: 'Drastic reduction in operational time and elimination of manual errors.'
        },
        {
          title: 'Massive SAP Data Extraction for BI',
          problem: 'Difficulty extracting large volumes of SAP data for analysis and reports.',
          solution: 'RFC integration for structured data extraction, with processing and sending to external system.',
          tech: 'Python, SAP RFC, REST APIs',
          result: 'Reliable, up-to-date data ready for strategic analysis.'
        },
        {
          title: 'SAP ↔ External System Integration via API',
          problem: 'External system needed to consume SAP data in near real-time.',
          solution: 'Creation of intermediary API to orchestrate communication between SAP and external system, with error handling and logs.',
          tech: 'C#, REST API, SAP ECC, JSON',
          result: 'Stable, traceable, and scalable integration.'
        },
        {
          title: 'RPA for SAP Financial Processes (FI)',
          problem: 'Repetitive financial postings prone to errors.',
          solution: 'RPA to automate SAP postings, with validations and status control.',
          tech: 'Python, SAP GUI, RPA',
          result: 'Increased productivity and reduced accounting inconsistencies.'
        },
        {
          title: 'Multiple RPA Orchestration',
          problem: 'Manual and disorganized execution of several interdependent RPAs.',
          solution: 'Orchestration script controlling sequential execution, status, and failures.',
          tech: 'Python, process automation',
          result: 'Predictable, controlled, and easy-to-scale process.'
        },
        {
          title: 'Pending Notification System Integrated with SAP',
          problem: 'Incomplete SAP requests generated delays and rework.',
          solution: 'System that identifies SAP pending items and triggers automatic email notifications.',
          tech: 'TypeScript, APIs, SAP, messaging',
          result: 'Fewer manual follow-ups and greater operational efficiency.'
        }
      ],
      labels: {
        problem: 'Problem',
        solution: 'Solution',
        tech: 'Technologies',
        result: 'Result'
      }
    },
    forCompanies: {
      title: 'For Companies and Freelancers',
      intro: 'I work in:',
      types: [
        'Full-time or contract positions',
        'On-demand freelance projects',
        'Recurring technical partnerships'
      ],
      differentials: 'Differentials:',
      diffItems: [
        'Direct and objective communication',
        'Business vision, not just code',
        'Measurable deliveries',
        'Solutions designed for real production'
      ]
    },
    contact: {
      title: 'Let\'s Talk?',
      subtitle: 'Let\'s automate your process or evolve your system?',
      cta: 'WhatsApp Me',
      email: 'Email',
      linkedin: 'LinkedIn',
      github: 'GitHub'
    },
    footer: {
      rights: '© 2025 Lucas Gonzales de Souza. All rights reserved.',
      tagline: 'Developing solutions that transform businesses'
    }
  }
};